function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "noun_envelope_737014",
  transform: "translate(-9.000000, -1.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(9.000000, 0.637820)"
}, React.createElement("path", {
  d: "M6,0.36218 C5.0848,0.36218 4.2121,0.56128 3.4375,0.92468 L38.0625,35.1122 C39.6817,36.7114 42.2527,36.7116 43.875,35.1122 L78.5312,0.92468 C77.7631,0.56878 76.9052,0.36218 76,0.36218 L6,0.36218 Z M0.5938,3.73718 C0.2116,4.52758 0,5.42228 0,6.36218 L0,50.3622 C0,51.3168 0.2316,52.2188 0.625,53.0184 L26.625,29.4559 L0.5938,3.73718 Z M81.4062,3.73718 L55.3438,29.4247 L81.375,53.0184 C81.7684,52.2188 82,51.3168 82,50.3622 L82,6.36218 C82,5.42228 81.7884,4.52758 81.4062,3.73718 L81.4062,3.73718 Z M52.5,32.2372 L46.6875,37.9559 C43.5306,41.0682 38.4056,41.0725 35.25,37.9559 L29.4688,32.2684 L3.5,55.8309 C4.2585,56.176 5.1096,56.3622 6,56.3622 L76,56.3622 C76.8904,56.3622 77.7415,56.176 78.5,55.8309 L52.5,32.2372 L52.5,32.2372 Z",
  id: "Shape"
}))));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "82px",
    height: "56px",
    viewBox: "0 0 82 56",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.0ce6250f.svg";
export { ForwardRef as ReactComponent };